import { render } from "./VitalChekInfo.vue?vue&type=template&id=46b0ac60"
import script from "./VitalChekInfo.vue?vue&type=script&lang=js"
export * from "./VitalChekInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__